import "core-js/stable"
import "regenerator-runtime/runtime"
import objectFitImages from "object-fit-images"

import Hero from "./hero"
import VideoHero from "./video-hero"
import MegaMenu from "./mega-menu"
import Accordions from "./accordions"
import Dropdowns from "./dropdowns"
import Menu from "./menu"
import Events from "./events"
import FeaturedNews from "./featured-news"
import FeaturedRaces from "./featured-races"
import Gallery from "./gallery"
import GridPages from "./grid-pages"
import MoonChallenge from "./moon-challenge"
import News from "./news"
import PageCards from "./page-cards"
import ProgramHero from "./program-hero"
import Formbuilder from "./formbuilder"
import Video from "./video"
import VideoGallery from "./video-gallery"
import Marquee from "./marquee"
import RaceNav from "./race-nav"
import Cards from "./cards"
import Privacy from "./privacy"

objectFitImages()

new MegaMenu()
new Hero()
new VideoHero()
new Marquee()
new Accordions()
new Dropdowns()
new Menu()
new Events()
new FeaturedNews()
new FeaturedRaces()
new Gallery()
new GridPages()
new MoonChallenge()
new News()
new PageCards()
new ProgramHero()
new Formbuilder()
new Video()
new VideoGallery()
new RaceNav()
new Cards()
new Privacy()
